import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Col } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import Button from 'react-bootstrap/lib/Button';
import IntlDate from '../../IntlDate';
import {S3_LINKS_DIV} from "js/constants";

class EditionsList extends React.Component {
  gotoEdition = editionId => {
    const { appIntl, history } = this.props;
    history.push(appIntl.urlPrefix + `editor/${editionId}`);
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      list,
      title,
    } = this.props;

    return list.data.count ? (
      <Col xs={12} md={6} className="m-t-20 grid-item">
        <div className="widget-11 card no-margin b-grey b-a">
          <div className="card-header p-t-20 p-l-15">
            <div className="card-title">{title}</div>
          </div>
          <div>
            <table className="table table-condensed table-hover">
              <tbody>
                {list.data.list.map((edition, i) => {
                  return i < 5 ? (
                    <tr key={edition.id} style={{ cursor: 'pointer' }} onClick={() => this.gotoEdition(edition.id)}>
                      <td className="text-center" width="120">
                        {edition.previews.length > 0 && edition.previews[0].key ? (
                          <img src={edition.previews[0].key} width="100" alt="" />
                        ) : (
                          <img
                            src={S3_LINKS_DIV.PDF_IMAGE_DEFAULT}
                            width="100"
                            alt=""
                          />
                        )}
                      </td>
                      <td className="font-secondary all-caps fs-12">{edition.title}</td>
                      <td className="text-right">
                        <span className="font-secondary fs-12">
                          {messages.campaign.last_edited} <IntlDate date={edition.mdate} />
                        </span>
                      </td>
                    </tr>
                  ) : null;
                })}
              </tbody>
            </table>
          </div>
          <div className="p-b-20">
            <p className="no-margin text-center">
              <Button href={appIntl.urlPrefix + 'account/campaigns'} className="text-master">
                <i className="fa fa-bars" /> {messages.view_all}
              </Button>
            </p>
          </div>
        </div>
      </Col>
    ) : (
      <Col xs={12} md={6} className="m-t-20 grid-item">
        <div className="widget-11 card no-margin b-grey b-a">
          <div className="card-header p-t-20 p-l-15">
            <div className="card-title">{title}</div>
          </div>
          <div>
            <p className="no-margin text-center">{messages.no_editions_to_display}</p>
          </div>
          <div className="p-b-20 p-t-10">
            <p className="no-margin text-center">
              <Button href={appIntl.urlPrefix + 'account/campaigns'} className="text-master">
                <i className="fa fa-bars" /> {messages.view_all}
              </Button>
            </p>
          </div>
        </div>
      </Col>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(EditionsList)));
